import { useRoutes, Navigate, Outlet } from 'react-router-dom';
// user context
import { UseUserState } from 'context/UserContext';

export default function RootTheme({ children }) {
    const { temaReady } = UseUserState();

    return <>{temaReady ? children : 'cargando temas...'}</>;
}
